<div class="form-group" [class.has-error]="showError" [class.has-success]="showSuccess">
    <div
        class="input-wrapper"
        [class.focused]="isFocused() || value()"
        [class.has-password-toggle]="showPasswordToggleButtonSig()"
    >
        <span *ngIf="prefixIconSig()" class="icon prefix">
            <i class="{{ prefixIconSig() }}"></i>
        </span>

        <ng-container [ngSwitch]="inputTypeSig()">
            <!-- Input -->
            <input
                *ngSwitchCase="'input'"
                [type]="displayTypeSig()"
                [value]="value()"
                [disabled]="disabledSig()"
                [attr.autocomplete]="autocompleteSig() || null"
                (input)="onInputChange($event)"
                (focus)="onFocus()"
                (blur)="onBlur()"
                class="form-control"
                [class.has-error]="showError"
                [class.has-success]="showSuccess"
            />

            <!-- Textarea -->
            <textarea
                *ngSwitchCase="'textarea'"
                [value]="value()"
                [disabled]="disabledSig()"
                (input)="onInputChange($event)"
                (focus)="onFocus()"
                (blur)="onBlur()"
                class="form-control"
                rows="4"
                [class.has-error]="showError"
                [class.has-success]="showSuccess"
            ></textarea>

            <!-- Select -->
            <select
                *ngSwitchCase="'select'"
                [value]="value()"
                [disabled]="disabledSig()"
                (change)="onInputChange($event)"
                (focus)="onFocus()"
                (blur)="onBlur()"
                class="form-control"
                [class.has-error]="showError"
                [class.has-success]="showSuccess"
            >
                <option value="" disabled hidden></option>
                <option
                    *ngFor="let opt of optionsSig()"
                    [value]="opt.value"
                    [selected]="opt.value === value()"
                >
                    {{ opt.label }}
                </option>
            </select>

            <!-- Datepicker -->
            <input
                *ngSwitchCase="'datepicker'"
                type="date"
                [value]="value()"
                [disabled]="disabledSig()"
                (input)="onInputChange($event)"
                (focus)="onFocus()"
                (blur)="onBlur()"
                class="form-control"
                [class.has-error]="showError"
                [class.has-success]="showSuccess"
                [class.has-value]="value()"
            />
        </ng-container>

        <span *ngIf="suffixIconSig()" class="icon suffix">
            <!-- <i class="{{ suffixIconSig() }}"></i> -->
            <img [src]="'public/svgs/'+suffixIconSig()" alt="">
        </span>

        <button
            *ngIf="showPasswordToggleButtonSig()"
            type="button"
            class="password-toggle"
            (mousedown)="onPasswordToggleMouseDown($event)"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="
                (passwordVisible()
                    ? 'app.auth.hidePassword'
                    : 'app.auth.showPassword') | translate
            "
            [attr.aria-pressed]="passwordVisible()"
        >
            <img
                [src]="
                    passwordVisible()
                        ? '/public/svgs/eye-off.svg'
                        : '/public/svgs/eye.svg'
                "
                alt=""
                aria-hidden="true"
            />
        </button>

        <label class="floating-label">{{ labelSig() }}</label>
    </div>

    <div *ngIf="showError" class="error-message">
        {{ firstErrorMessage }}
    </div>

    <div *ngIf="complexitySig()" class="pwd-complexity">
        <div class="line" [ngClass]="{'line__red': complexity1Sig()}"></div>
        <div class="line" [ngClass]="{'line__orange': complexity2Sig()}"></div>
        <div class="line" [ngClass]="{'line__orange': complexity3Sig()}"></div>
        <div class="line" [ngClass]="{'line__green': complexity4Sig()}"></div>
    </div>

    <div *ngIf="complexitySig()" class="pwd-hint" >
        <ul class="list">
            <li *ngFor="let error of pwdErrors()" class="list-item" [class.valid]="errors?.hasOwnProperty(error) && errors?.[error] === false || control?.valid">
                <img width="16" height="16" src="/public/svgs/check.svg" alt="">
                <span>{{ 'app.auth.' + error | translate }}</span>
            </li>
        </ul>
    </div>

</div>
